import { useEffect, useState } from "react";
import api from "@/lib/api";
import { FACULTY } from "@/data/faculty";

// Static roster plus admin-approved faculty profiles
export const useFacultyRoster = () => {
  const [extra, setExtra] = useState([]);
  useEffect(() => {
    const known = new Set(FACULTY.map((f) => f.slug));
    api.get("/faculty").then((r) => setExtra((r.data || []).filter((f) => !known.has(f.slug)))).catch(() => {});
  }, []);
  return [...FACULTY, ...extra];
};
